import React, { useState } from "react";
import AboutUs from "../components/AboutUs";
import assets from "../../../shared/constants/assetVariables";

function AboutUsContainer() {
  const [pageDetails] = useState({
    title: "Meet the Team",
    subtitle:
      "Our team blends creative, technical, and strategic talents. Quality is important to us, and we work hard to develop solutions that matter.",
  });

  const [teamMembersOne] = useState([
    {
      name: "Mithun Suvarna",
      linkedInUrl: "https://www.linkedin.com/in/mithun-suvarna-ba50a057/",
      role: " Co-Founder & CEO",
      roleDesc:
        "Environmental, Social and Governance (ESG) Expert having 15 years of experience in Corporate Sustainability & Responsible Investment majorly at Thomson Reuters. Has thorough understanding of all major ESG Guidelines namely GRI,SASB, SDG, CDP, TCFD, BRSR and IR, etc. Holds MBA in Finance & Marketing.",
      profilePic: assets.images.mithunPic,
    },
    {
      name: "Satish Ramchandani",
      linkedInUrl: "https://www.linkedin.com/in/satish-ramchandani-936a042/",
      role: "Co-Founder & Chief Business Officer",
      roleDesc:
        "20 years of experience in Sales & Marketing, Strategy, Governance and CSR. Leadership roles with firms such as CRISIL (S&P Ratings), Edelweiss Financial Services, Bank of America Merrill Lynch. Chartered Accountant and MBA by qualification.",
      profilePic: assets.images.satishPic,
    },
    {
      name: "Supreeth Rao",
      linkedInUrl: "https://www.linkedin.com/in/supreeth-rao-695375b7/",
      role: "Co-Founder & CFO",
      roleDesc:
        "Experience in Advisory, Taxation, Finance & Litigation. Worked for Ernst & Young (EY) and advised clients in various industries including pharma, services, IT & trading.",
      profilePic: assets.images.supreethPic,
    },
    {
      name: "Akash A",
      linkedInUrl: "https://www.linkedin.com/in/akash-poojary-75a22769/",
      role: "Chief Technology Officer",
      roleDesc:
        "Engineering Leader with 12+ years' experience driving technology initiatives, innovation, and leveraging technical expertise for global collaboration.",
      profilePic: assets.images.akashPic,
    },
  ]);

  const [teamMembersTwo] = useState([
    {
      name: "Erik Solheim",
      linkedInUrl: "https://no.linkedin.com/in/erik-solheim-a9464b225",
      role: "Advisory Board Member",
      roleDesc:
        "15+ years of experience in Energy, Carbon Emissions Analysis and SRI.",
      profilePic: assets.images.ericSolheimPic,
    },

    {
      name: "Maryam Telmesani",
      linkedInUrl: "https://www.linkedin.com/in/maryam-telmesani-60780b83/",
      role: "Advisory Board Member",
      roleDesc:
        "15+ years of experience in Energy, Carbon Emissions Analysis and SRI.",
      profilePic: assets.images.maryamTelmesani,
    },
    {
      name: "Dr. Sanmi Olowosile",
      linkedInUrl: "https://www.linkedin.com/in/olowosile-sanmi/",
      role: "Advisory Board Member",
      roleDesc:
        "15+ years of experience in Energy, Carbon Emissions Analysis and SRI.",
      profilePic: assets.images.sanmiO,
    },
    {
      name: "Bélinda Sabatier Mondjo",
      linkedInUrl: "https://www.linkedin.com/in/belinda-sabatier-mondjo",
      role: "Advisory Board Member",
      roleDesc: "",
      profilePic: assets.images.belindaSabatierMondjo,
    },
    // {
    //   name: "Vineet Agarwal",
    //   linkedInUrl: "https://www.linkedin.com/in/vineet-agarwal-10a5829/",
    //   role: "Advisory Board Member",
    //   roleDesc: "15+ years of experience in Energy, Carbon Emissions Analysis and SRI.",
    //   profilePic: assets.images.vineetAgarwal,
    // },
  ]);

  const [teamMembersThree] = useState([
    // {
    //   name: "Bélinda Sabatier Mondjo",
    //   linkedInUrl: "https://www.linkedin.com/in/belinda-sabatier-mondjo",
    //   role: "Advisory Board Member",
    //   roleDesc: "",
    //   profilePic: assets.images.belindaSabatierMondjo,
    // },

    {
      name: "Santhosh Jayaram",
      linkedInUrl: "https://www.linkedin.com/in/santhosh-jayaram-145270b/",
      role: "Advisory Board Member",
      roleDesc:
        "Ex-Partner at KPMG, EX-Business Head at DNV. 30+ years of experience driving sustainability, climate action & policy innovation through senior roles in global corporations",
      profilePic: assets.images.santhoshJayaram,
    },

    // {
    //   name: "Pallavi Singh",
    //   linkedInUrl: "https://www.linkedin.com/in/pallavi-singh-4a65b114/",
    //   role: "Chief Customer Officer",
    //   roleDesc:
    //     "17+ years of experience in climate, decarbonization, ESG strategy & disclosures",
    //   profilePic: assets.images.pallaviSingh,
    // },
  ]);

  return (
    <AboutUs
      teamMembersOne={teamMembersOne}
      teamMembersTwo={teamMembersTwo}
      teamMembersThree={teamMembersThree}
      pageDetails={pageDetails}
    ></AboutUs>
  );
}

export default AboutUsContainer;
